module.exports = "images/france-4.5c41723c.png";